import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import SelectionTabsComponent from 'components/SelectionTabsComponent/SelectionTabsComponent'
// import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
// import Avatar from '@material-ui/core/Avatar'
// import BarIcon from '@material-ui/icons/LocalBar'
const styles = theme => ({
  chip: {
    margin: theme.spacing.unit
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: 48
  }
})
class SelectionModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    selectedProducts: PropTypes.array,
    addProductsToTransaction: PropTypes.func,
    transfertTransaction: PropTypes.func,
    clearSelectedProducts: PropTypes.func,
    currentTransaction: PropTypes.object
  }
  state = {
    selectedTransaction: void 0,
    selectedTarget: void 0
  }
  handleValidate = () => {
    const { selectedTransaction, selectedTarget } = this.state
    if (!selectedTransaction && !selectedTarget) return
    if (this.props.currentTransaction && this.props.transfertTransaction) {
      this.props.transfertTransaction(
        this.props.currentTransaction,
        selectedTarget,
        selectedTarget.type ? 'POOL' : 'BAR'
      )
      this.props.history.replace('/home')
    }
    if (
      !this.props.currentTransaction &&
      this.props.addProductsToTransaction &&
      this.props.clearSelectedProducts
    ) {
      this.props.addProductsToTransaction(
        this.state.selectedTransaction,
        this.props.selectedProducts
      )
      this.props.clearSelectedProducts()
    }
  }
  handleSelectTransaction = transaction => {
    this.setState({ selectedTransaction: transaction })
  }
  handleSelection = targetTransfert => {
    this.setState({ selectedTarget: targetTransfert })
  }
  componentDidMount() {}
  render() {
    const { classes, currentTransaction } = this.props
    const { selectedTransaction, selectedTarget } = this.state
    let title = ''
    let headerTitle = ''
    if (
      currentTransaction &&
      currentTransaction.type === 'POOL' &&
      currentTransaction.pool
    ) {
      headerTitle = `Transférer ${currentTransaction.pool.table.name}`
    } else if (
      currentTransaction &&
      currentTransaction.type === 'BAR' &&
      currentTransaction.bar
    ) {
      headerTitle = `Transférer ${currentTransaction.bar.name}`
    } else if (this.props.selectedProducts) {
      headerTitle = 'Ajouter des produits'
    }
    if (selectedTransaction) {
      if (selectedTransaction.type === 'POOL') {
        title = selectedTransaction.pool.table.name
      } else if (selectedTransaction.type === 'BAR') {
        title = selectedTransaction.bar.name
      }
    }
    if (selectedTarget) {
      title = selectedTarget.name
    }
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleValidate}
        title={headerTitle}
        cancelText="Annuler"
        okDisabled={!selectedTransaction && !selectedTarget}
        showOk>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid style={{ marginBottom: 8 }} item xs={6}>
            <Paper className={classes.paper}>
              {!selectedTransaction &&
                !selectedTarget && (
                  <Typography variant="caption" gutterBottom>
                    Aucune sélection
                  </Typography>
                )}
              {(selectedTransaction || selectedTarget) && (
                <Typography variant="title" gutterBottom>
                  {title}
                </Typography>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <SelectionTabsComponent
              currentTransaction={currentTransaction}
              onSelect={
                currentTransaction
                  ? this.handleSelection
                  : this.handleSelectTransaction
              }
            />
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withRouter(withStyles(styles)(SelectionModal))



// WEBPACK FOOTER //
// ./src/components/modals/client/SelectionModal.js